import { render } from "./PageCollection.vue?vue&type=template&id=6b8b46c2&scoped=true"
import script from "./PageCollection.vue?vue&type=script&lang=js"
export * from "./PageCollection.vue?vue&type=script&lang=js"

import "./pageCollectionStyle.scss?vue&type=style&index=0&id=6b8b46c2&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8b46c2"]])

export default __exports__